import Icon from "@ant-design/icons";

const SVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.887"
    height="21.496"
    viewBox="0 0 26.887 21.496"
  >
    <g
      id="Group_2125"
      data-name="Group 2125"
      transform="translate(-115.556 -22.25)"
    >
      <g id="trending-up" transform="translate(120.484 19.31)">
        <path
          id="Path_1082"
          data-name="Path 1082"
          d="M20.032,6l-8.218,8.218L7.488,9.893,1,16.381"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_1083"
          data-name="Path 1083"
          d="M17,6h6v6"
          transform="translate(-2.968)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
      <path
        id="Path_1093"
        data-name="Path 1093"
        d="M110.368,17.822v20h25.387"
        transform="translate(5.938 5.178)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

const AntdIcon = (props) => <Icon component={SVG} {...props} />;

export default AntdIcon;
